import { Component, Input, OnInit, ViewEncapsulation } from '@angular/core';
import { GrayoutService, QuickQuoteService, TravelPartyService } from '@wdpr/dcl-ui-components-library';
import { CruiseListingAnalyticsModel } from '@interfaces/cruise-listing-analytics-model';
import { FilterOptionData } from '@interfaces/filter-option-data';
import { CruiseListingDataService } from '@services/cruise-listing/cruise-listing.service';
import { ConfigService } from '@app/core/config.service';
import { TravelAgentService } from '@wdpr/dcl-ui-components-library';
import { HomepageAnalyticsService } from '@app/services/analytics/analytics.service';
import { ANALYTICS_CONSTANTS } from '@app/services/analytics/analytics.constants';

@Component({
    selector: 'pixie-homepage',
    templateUrl: './homepage.component.html',
    styleUrls: ['./homepage.component.scss'],
    encapsulation: ViewEncapsulation.None,
})
export class HomepageComponent implements OnInit {

    id = '';
    title = '';
    ctas = '';
    filters: FilterOptionData;
    cruiseListURL = '';
    contextPath = '';
    isDclClRefactorPhase2: boolean;
    isAdvancedBookingPhase3: boolean;
    siteId;

    constructor(
        private quickQuoteService: QuickQuoteService,
        private cruiseListingService: CruiseListingDataService,
        private configService: ConfigService,
        private travelAgentService: TravelAgentService,
        private analyticsService: HomepageAnalyticsService,
    ) { }

    ngOnInit() {
        const featureToggles = this.configService.getValue('featureToggles');

        this.siteId = this.configService.getValue('siteId');
        this.isDclClRefactorPhase2 = !!(featureToggles && featureToggles.dclClRefactorPhase2);
        this.isAdvancedBookingPhase3 = !!(featureToggles && featureToggles.dclAdvancedBookingPhase3);
        this.cruiseListURL = this.configService.getValue('cruiseListURL');
        this.quickQuoteService.onApplyFilters.subscribe((data: string[]) => this.onApplyFilters(data));

        if (this.siteId === 'dcl') {
            this.setDCLQQFilterOptions();
        }

        this.travelAgentService.setFlowEnabled(true);
        this.travelAgentService.setRestBaseUrl(this.configService.getValue('travelAgentWebApiUrl'));
    }

    onApplyFilters(filters: string[]): void {
        /*
        if (window.location.hash) {
            console.log('qq hash ', window.location.hash);
            this.cruiseListURL += window.location.hash;
        }
        */
        window.location.href = this.cruiseListURL;
    }

    setDCLQQFilterOptions(): void {
        this.cruiseListingService.getFilters().subscribe(
            (filters: FilterOptionData) => {
                this.contextPath = 'wdpr-web-dcl-homepage';
                this.filters = filters;
            },
            () => console.log('qq error')
        );
    }

    /**
     * Receives the analytics data from the respective triggered Event Emitter
     * @param analyticsData object with the values needed for Analytics Function.
     */
    analyticsTrackingEvent(analyticsData: CruiseListingAnalyticsModel): void {
        console.log('qq analytics event');
        analyticsData.pageVariant = ANALYTICS_CONSTANTS.PAGE_VARIANT;
        analyticsData.bookingSearchPartySize = analyticsData.bookingSearchPartySize;
        analyticsData.bookingSearchNumResults = analyticsData.bookingSearchNumResults;
        analyticsData.facetsUtilized = analyticsData.facetsUtilized;
        analyticsData.productsDisplayedEvent = analyticsData.productsDisplayedEvent;
        analyticsData.productsDisplayed = analyticsData.productsDisplayed;
        this.analyticsService.trackLink(analyticsData.trackLinkID, analyticsData);
    }
}
